import { useCallback, useMemo } from 'react';
import { useSubscriptionPlans } from './useSubscriptionPlans';
import { usePaymentControlState } from './usePaymentControlState';
import { PlanFamily } from 'src/types';

export const useGetDisplayedPlan = () => {
  const { getDisplayedPlanKindByFamily, selectedFamily, selectedPlan } =
    usePaymentControlState();

  const { plans, isPlansLoading } = useSubscriptionPlans({
    families: [PlanFamily.PRO, PlanFamily.MAX, PlanFamily.BUSINESS],
  });

  const getDisplayedPlan = useCallback(
    (planFamily: PlanFamily) => {
      const displayedPlanKind = getDisplayedPlanKindByFamily(planFamily);

      return plans?.find((plan) => plan.plan_kind === displayedPlanKind);
    },
    [plans, getDisplayedPlanKindByFamily],
  );

  const currentSelectedPlan = useMemo(
    () => (selectedFamily ? getDisplayedPlan(selectedFamily) : undefined),
    [selectedFamily, getDisplayedPlan],
  );

  const currentSelectedPlanV2 = useMemo(
    () =>
      selectedPlan
        ? plans?.find((plan) => plan.plan_kind === selectedPlan)
        : undefined,
    [selectedPlan, plans],
  );

  return useMemo(
    () => ({
      plans,
      isPlansLoading,
      currentSelectedPlan,
      getDisplayedPlan,
      currentSelectedPlanV2,
    }),
    [
      plans,
      isPlansLoading,
      getDisplayedPlan,
      currentSelectedPlan,
      currentSelectedPlanV2,
    ],
  );
};
